<template>
    <Message v-if="!hasCurrentMonthSelections" size="large" severity="info" icon="pi pi-info-circle"
        class="flex items-start gap-4">
        <div class="flex-1">
            <h4>
                {{ $t("prizes.alerts.selectionsNeeded.title") }}
            </h4>
            <p class="text-sm">
                {{ $t("prizes.alerts.selectionsNeeded.description") }}
            </p>
            <p class="text-sm">
                {{ $t("prizes.alerts.selectionsNeeded.message", currentMonthSelections.length) }}
            </p>
            <div class="flex gap-2 mt-2">
                <Button @click="showSelectionsModal = true" size="small" severity="warning">
                    {{ $t("prizes.alerts.selectionsNeeded.action") }}
                </Button>
                <RouterLink to="/settings/prizes">
                    <Button size="small" severity="secondary" outlined>
                        {{ $t("prizes.alerts.selectionsNeeded.settings") }}
                    </Button>
                </RouterLink>
            </div>
        </div>
    </Message>

    <!-- Prize selections modal -->
    <PrizeSelectionsModal v-model:showModal="showSelectionsModal" />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { usePrizesStore } from '@/stores';
import PrizeSelectionsModal from './PrizeSelectionsModal.vue';
import { storeToRefs } from "pinia";

const prizesStore = usePrizesStore();
const { currentMonthSelections } = storeToRefs(prizesStore);

const showSelectionsModal = ref(false);

const hasCurrentMonthSelections = computed(() => currentMonthSelections.value.length === 3);
</script>